import { Injectable } from '@angular/core';
import {
  Http,
  Headers,
  RequestOptions,
  ResponseContentType
} from '@angular/http';
import { TokenService } from './token.service';
import { Granule } from '../../config';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class ApiService {
  private endpointApi: string = this.granule.CMS_ROUTE_API +
    this.granule.CMS_ROUTE_URI;

  constructor(
    private http: Http,
    private granule: Granule,
    private tokenService: TokenService
  ) {}

  private generateOptions(): RequestOptions {
    // add JWT to header
    const headers = new Headers({
      Authorization: `Bearer ${this.tokenService.getToken()}`
    });

    const options = new RequestOptions({
      headers: headers
    });

    return options;
  }

  private formatErrors(error: any) {
    return Observable.throw(error.json());
  }

  // wrap get method returning Observable
  get(path: string): Observable<any> {
    return this.http
      .get(`${this.endpointApi}${path}`, this.generateOptions())
      .catch(this.formatErrors)
      .map((res: Response) => res.json());
  }

  // wrap get method returning Promise
  getPromise(path: string): Promise<any> {
    return this.http
      .get(`${this.endpointApi}${path}`, this.generateOptions())
      .catch(this.formatErrors)
      .toPromise()
      .then((res: Response) => res.json());
  }

  // wrap put method returning Observable
  put(path: string, body: any): Observable<any> {
    return this.http
      .put(`${this.endpointApi}${path}`, body, this.generateOptions())
      .catch(this.formatErrors)
      .map((res: Response) => res.json());
  }

  // wrap post method returning Observable
  post(path: string, body: any): Observable<any> {
    return this.http
      .post(`${this.endpointApi}${path}`, body, this.generateOptions())
      .catch(this.formatErrors)
      .map((res: Response) => res.json());
  }

  // to download attachments
  postDownloadImage(path: string, body: any): Observable<any> {
    return this.http
      .post(`${this.endpointApi}${path}`, body, {
        responseType: ResponseContentType.Blob,
        headers: new Headers({
          Authorization: `Bearer ${this.tokenService.getToken()}`
        })
      })
      .catch(this.formatErrors)
      .map((res: Response) => res.blob());
  }

  // wrap post method returning Promise
  postPromise(path: string, body: any): Promise<any> {
    return this.http
      .post(`${this.endpointApi}${path}`, body, this.generateOptions())
      .catch(this.formatErrors)
      .toPromise()
      .then((res: Response) => res.json());
  }

  // wrap delete method returning Observable
  delete(path: string): Observable<any> {
    return this.http
      .delete(`${this.endpointApi}${path}`, this.generateOptions())
      .catch(this.formatErrors)
      .map((res: Response) => res.json());
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/services/api.service.ts